import { AreaOfInterestDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { useApiClient } from '@/api/util/useApiClient.util.ts';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

interface Return {
  activeAreaOfInterests: AreaOfInterestDto[] | undefined;
  error: AxiosError | null;
  isLoading: boolean;
}

export const useActiveAreaOfInterests = (): Return => {
  const { restAreaOfInterestsApi } = useApiClient();

  const { data, error, isPending } = useQuery<AreaOfInterestDto[] | undefined, AxiosError>({
    queryFn: async () => {
      const response = await restAreaOfInterestsApi.getActiveAreaOfInterests();
      return response.data;
    },
    queryKey: [QueryKeyEnum.ACTIVE_AREA_OF_INTERESTS],
    staleTime: Infinity,
  });

  return { activeAreaOfInterests: data, error, isLoading: isPending };
};
